const sortItems = (items: any, config: string) => {
    return items.sort((a, b) => a[config].localeCompare(b[config]))
};
export default sortItems;